import React from "react";
import { useNavigate } from "react-router-dom";

const VendorPrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-4 py-10 sm:px-6 lg:px-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="mb-8 flex items-center text-[#2A668D] hover:underline"
      >
        <span className="material-symbols-outlined mr-1">arrow_back</span>
        Back
      </button>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-[#2A668D] mb-6 text-center">
          Privacy Policy
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6 text-justify">
          This Privacy Policy describes how we collect, use, and protect your personal information when you register as a vendor on our platform.
        </p>

        <div className="space-y-5 text-gray-700 text-justify">
          <p>
            <strong>1. Information Collection:</strong> We collect personal and business details during registration and transactions.
          </p>
          <p>
            <strong>2. Use of Data:</strong> Your data is used strictly for service delivery, communication, and platform improvement.
          </p>
          <p>
            <strong>3. Data Protection:</strong> We apply industry-standard security measures to safeguard your information.
          </p>
          <p>
            <strong>4. Sharing:</strong> We do not sell or rent your data to third parties.
          </p>
          <p>
            <strong>5. Your Rights:</strong> You can request access, modification, or deletion of your data at any time.
          </p>
        </div>

        <div className="text-gray-600 text-sm text-center mt-10">
          Last updated: {new Date().toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default VendorPrivacyPolicy;
